import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { AlgorithmExtendedType } from '../schema/types';

export const useUsedAlgorithmSourceIds = ({
  excludeIndex = Infinity,
  untilIndex = Infinity,
} = {}): number[] => {
  const algorithmJoins = useWatch<AlgorithmExtendedType, 'joins'>({
    name: 'joins',
  });

  return useMemo(
    () =>
      (untilIndex ? algorithmJoins.slice(0, untilIndex) : algorithmJoins)
        .filter((j, index) => j.algorithmSourceId && index !== excludeIndex)
        .map((j) => j.algorithmSourceId),
    [algorithmJoins, excludeIndex, untilIndex]
  );
};
